import React from "react";
import { Modal } from "components/common";
import { Button, Image } from "components/ui";
import { connectReduxReducers } from "hocs";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ShareButton from "components/panzofi/sharebutton";
import { useTranslation } from "react-i18next";
const QuizAttemptModal = ({
  auth,
  courses,
  quiz,
  is_visible,
  closeModal,
  history,
}) => {
  const { t } = useTranslation();
  const [index, setIndex] = React.useState(-1);
  const [results, setResults] = React.useState(null);
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  React.useEffect(() => {
    setIndex(-1);
    setResults(null);
    setSelectedOptions([]);
    // eslint-disable-next-line
  }, [is_visible]);

  //   const handleSubmit = (data) => {
  //     profile.createQuestionnaire(data, (response) => {
  //       if (response.status === 201) {
  //         console.log("cerrado");
  //         closeModal(true);
  //       }
  //     });
  //   };

  const goToNextPage = () => {
    setIndex(index + 1);
  };

  const handleOptionSelect = (optionId) => {
    setSelectedOptions([...selectedOptions, optionId]);
    goToNextPage();
  };

  const submitTriviaAttempt = () => {
    // Prepare data for submission
    const triviaAttemptData = {
      triviaId: quiz.id,
      answers: quiz.questions.map((question, index) => ({
        questionId: question.id,
        selectedOptionIndex:
          selectedOptions[index] !== undefined ? selectedOptions[index] : null,
      })),
    };

    // Send data to the backend
    courses.createQuizAttempt(quiz.id, triviaAttemptData, (response) => {
      if (response.status === 201) {
        setResults(response.data);
      }
    });
  };

  return (
    <Modal
      is_visible={is_visible}
      closeModal={closeModal}
      exitOnOverlayClick
      contentClassName="grid grid-gap-20"
      className="bigger-modal"
    >
      <section className="pz-profile__trivia">
        {results ? (
          <section className="grid grid-gap-20 grid-content-center grid-items-center">
            <h1>{t("modals.quiz_attempt.results_title")}</h1>

            <section className="grid grid-gap-20 grid-content-center grid-items-center">
              {results?.passed === true ? (
                <>
                  <h3>{t("modals.quiz_attempt.results_pass")}</h3>
                  <Image
                    name="ilustrations/quiz_passed.svg"
                    className="pz-profile__trivia--img"
                  />
                </>
              ) : (
                <>
                  <h3>{t("modals.quiz_attempt.results_fail")}</h3>
                  <Image
                    name="ilustrations/quiz_failed.svg"
                    className="pz-profile__trivia--img"
                  />
                </>
              )}
              <h3>
                {t("modals.quiz_attempt.results", { score: results?.score })}
              </h3>
              <section className="pz-profile__trivia--actions">
                <Button thin onClick={closeModal}>
                  {t("modals.quiz_attempt.close_btn")}
                </Button>
                <ShareButton
                  hashtag={`¡Obtuve ${results?.score} en un curso panzofi, intentalo tu tambien!`}
                  title={`¡Obtuve ${results?.score} en un curso panzofi, intentalo tu tambien!`}
                />
              </section>
            </section>
          </section>
        ) : index === -1 ? (
          <section className="grid grid-gap-20 grid-content-center grid-items-center">
            <h1>{quiz?.title}</h1>
            <h3>{quiz?.description}</h3>
            <Image
              name="ilustrations/quiz.svg"
              className="pz-profile__trivia--img"
            />
            <section className="grid-columns grid-gap-20 ">
              <Button secondary onClick={goToNextPage}>
                {t("modals.quiz_attempt.start_btn")}
              </Button>
              <Button onClick={closeModal}>
                {t("modals.quiz_attempt.close_btn")}
              </Button>
            </section>
          </section>
        ) : index === quiz?.questions?.length ? (
          <section className="grid grid-content-center grid-items-center">
            <h1>{t("modals.quiz_attempt.finished_title")}</h1>
            <h3>{t("modals.quiz_attempt.finished_desc")}</h3>
            <section className="pz-profile__trivia--options">
              <Button secondary onClick={submitTriviaAttempt}>
                {t("modals.quiz_attempt.send_btn")}
              </Button>
            </section>
          </section>
        ) : (
          <section className="grid-content-center">
            <h5 className="pz-modal__page">
              {index + 1}/{quiz?.questions?.length}
            </h5>
            <h2>{quiz?.questions[index]?.text}</h2>
            <section className="pz-profile__trivia--options">
              {quiz?.questions[index]?.options.map((opt, key) => {
                return (
                  <Button
                    secondary
                    ghost
                    key={key}
                    onClick={() => handleOptionSelect(opt.id)}
                  >
                    {opt.text}
                  </Button>
                );
              })}
            </section>
            {quiz?.questions[index].url ? (
              <h5 className="grid-self-right">
                {t("modals.quiz_attempt.link_input")}{" "}
                <a
                  className="bold"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={quiz?.questions[index].url}
                >
                  {t("modals.quiz_attempt.link")}{" "}
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="pz-landing__button--icon"
                  />
                </a>
              </h5>
            ) : null}
          </section>
        )}
      </section>
    </Modal>
  );
};

export default withRouter(
  connectReduxReducers(QuizAttemptModal, "courses", "auth")
);
